import angular from 'angular';
import Userauth from './userauth';
import UserBilling from './userbilling';
import Analytics from './appanalytics';

const serviceModule = angular.module('app.services', [
  Userauth.name,
  UserBilling.name,
  Analytics.name
]);

export default serviceModule;



// WEBPACK FOOTER //
// ./client/app/services/services.js